import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ErrorAnimation from '../components/ErrorAnimation';
import { useAuth } from "../components/context/AuthContext";

// Mensajes según el parámetro ?error= que envía la pasarela en la redirección
// (ej: PVS redirige a /pago-fallido?error=rechazado)
const MENSAJES_ERROR = {
  rechazado: 'Tu pago fue rechazado por la entidad financiera.',
  rejected: 'Tu pago fue rechazado por la entidad financiera.',
  expirado: 'El tiempo para completar el pago expiró.',
  expired: 'El tiempo para completar el pago expiró.',
  cancelado: 'El pago fue cancelado.',
  cancelled: 'El pago fue cancelado.',
};

const primaryButtonStyle = {
  backgroundColor: "#5656FF",
  border: "2px solid #5656FF",
  color: "#fff",
  padding: "6px 18px",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: "600",
};

const outlinedButtonStyle = {
  ...primaryButtonStyle,
  backgroundColor: "transparent",
  color: "#5656FF",
};

const PaymentRejected = () => {
  const { isAuthenticated } = useAuth();
  const history = useHistory();
  const { search } = useLocation();
  const error = (new URLSearchParams(search).get('error') || '').toLowerCase();

  const mensaje = MENSAJES_ERROR[error] || 'Tu pago no pudo ser procesado.';

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#fff", width: "100%", paddingTop: "4%", paddingBottom: "48px" }}>
      <div style={{ maxWidth: "720px", margin: "0 auto", padding: "0 24px" }}>
        <div className='d-flex flex-column justify-content-center align-items-center mb-4'>
          <ErrorAnimation />
          <p style={{
            color: "#0b0062",
            fontWeight: "600",
            fontSize: "clamp(24px, 5vw, 38px)",
            textAlign: "center",
            marginTop: "24px",
            marginBottom: "5px"
          }}>No pudimos procesar tu pago</p>
          <span style={{
            color: "#6C757D",
            fontSize: "16px",
            textAlign: "center",
            maxWidth: "100%",
            padding: "0 10px"
          }}>
            {mensaje}
          </span>
        </div>

        <div className='mt-4' style={{ padding: "0 16px" }}>
          <p style={{ color: "#0b0062", fontSize: "clamp(18px, 4vw, 22px)", fontWeight: "600", marginBottom: "8px" }}>
            ¿Qué podés hacer?
          </p>
          <ul style={{ color: "#6C757D", fontSize: "16px", paddingLeft: "20px", marginBottom: "8px" }}>
            <li>Verificar que tu medio de pago tenga fondos suficientes.</li>
            <li>Revisar que tu tarjeta esté habilitada para compras online.</li>
            <li>Intentar nuevamente con otro medio de pago.</li>
          </ul>
          <p style={{ color: "#6C757D", fontSize: "16px", marginBottom: "40px" }}>
            Si el problema persiste, escribinos a{' '}
            <a href="mailto:soporte@passgo.com.ar" style={{ color: "#5656ff", fontWeight: "600" }}>soporte@passgo.com.ar</a>
          </p>

          <div className="d-flex flex-wrap justify-content-center gap-3">
            <button type="button" className="btn" style={primaryButtonStyle} onClick={() => history.push('/')}>
              Volver al inicio
            </button>
            {isAuthenticated && (
              <button type="button" className="btn" style={outlinedButtonStyle} onClick={() => history.push('/mis-compras')}>
                Mis compras
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentRejected;
